export default {
    change(state){
        state.testData ++;
    },
    actionChange(state,payload){
        state.actionData ++;
        state.testData ++;
    },
    CHANGE_META(state,data){
        // console.log(state)
        // console.log(data)
    },
    setWebConfig(state, data) {
        state.webConfig = data
    }
}